module.exports = "<ul class=\"em-info-popup-tip hide\"> <% _.each(items, function(itm, menuId){ %> <li class=popup-item menuid=\"<%= menuId %>\"> <a><%= itm.name %></a> </li> <% }) %> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/app/pages/main/uikit/template/popupListTpl.html
// module id = 245
// module chunks = 0